import { render, staticRenderFns } from "./leaveshenpi.vue?vue&type=template&id=f6e610e6"
import script from "./leaveshenpi.vue?vue&type=script&lang=js"
export * from "./leaveshenpi.vue?vue&type=script&lang=js"
import style0 from "./leaveshenpi.vue?vue&type=style&index=0&id=f6e610e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports